
    <ezs-account-registration 
      (registerAccount)="registerAccount($event)">
    </ezs-account-registration>
  